import AOS from "aos";

import { initHeadroom } from "./_headroom";
import { initSlider } from "./_slider";
import { initTransitions } from "./_transitions.js";
import { initVariableBg } from "./_variable-bg.js";
import { initDetailGrid } from "./_detail-grid.js";


var mobileThreshold = 992;
var isMobile = window.innerWidth < mobileThreshold;

// debug
let isDebug = document.location.hash.indexOf('#debug') == 0;

const app = document.querySelector("#app");
const header = document.querySelector('.site-header');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    require("bootstrap");
} catch (e) {
	console.error(e);
}

// inits
jQuery(function($) {
    initHeadroom($);
    initSlider($);
	dropdownLinks($);
	initVariableBg($);
	initDetailGrid($);

	AOS.init({
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 0, // offset (in px) from the original trigger point
        delay: 250, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: "ease", // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    // init transitions
    initTransitions($);

	// Refresh AOS
    AOS.refreshHard();
});


function dropdownLinks($) {
	$('.secondary-dropdown').each(function(n, el) {
		let dropdown = $(el);
		let id = $(el).attr('id');
		var button = $("[aria-controls='" + id + "']");
		var close = dropdown.find('.secondary-dropdown-close');

		close.on('click', (e) => {
			e.preventDefault();
			$('.secondary-dropdown').removeClass('show');
		});

		button.on('click', (e) => {
			e.preventDefault();
			$('.secondary-dropdown').removeClass('show');
			dropdown.toggleClass('show');
		});
	});
}